import { Injectable } from "@angular/core";
import { IBillingDocument, IBillingDocumentNames, IBillingDocumentTypes } from "../billing-documents.interface";
import { Observable } from "rxjs";
import { HttpService } from "../../../../../http.service";
import { UtilsService } from "../../../../shared/services/utils.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { apiURL, EnvConfig } from "../../../../../env-config";

@Injectable()
export class CorrectiveInvoiceService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) { }

  getCorrectiveInvoice(document: IBillingDocument | string): Observable<any> {
    let id = (typeof document == 'string') ? document : document._id;
    return this._http.get(`${apiURL(EnvConfig.API_CORRECTIVE_INVOICES)}/${id}`);
  }

  createCorrectiveInvoice(document: IBillingDocument): Observable<any> {
    document.client = (typeof document.client == 'string') ? document.client : document.client?._id;
    return this._http.post(`${apiURL(EnvConfig.API_CORRECTIVE_INVOICES)}`, document);
  }

  updateCorrectiveInvoice(document: IBillingDocument): Observable<any> {
    let id = document._id;
    delete document._id;
    return this._http.patch(`${apiURL(EnvConfig.API_CORRECTIVE_INVOICES)}/${id}`, document);
  }

  download(id: string, name: string = 'document') {
    let query = { "company": this._AuthService.companyId(), "extended": true }
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_CORRECTIVE_INVOICES)}/${id}/generatePdf${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      this._utilsService.blobToFile(file, "application/pdf", name + '.pdf');
    });
  }

  sendEmail(id?: string, data?: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_CORRECTIVE_INVOICES)}/${id}/sendEmail`, data);
  }

  getCorrectiveInvoicePDFURL(document: IBillingDocument | string, extended: boolean = false): string {
    let id = (typeof document == 'string') ? document : document._id;
    return `${apiURL(EnvConfig.API_CORRECTIVE_INVOICES)}/${id}/generatePDF` + (extended ? '?extended=true' : '');
  }

  getCorrectiveInvoicePDF(document: IBillingDocument | string, extended: boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.getCorrectiveInvoicePDFURL(document, extended);
      this._http.get(url, { responseType: "arraybuffer" }).subscribe(file => {
        resolve(this._utilsService.blobToObjectURL(file, "application/pdf"));
      });
    });
  }

}